const langIt_unicomm_cash = {
  "df-store-card.store-selection": "Scegli il punto vendita",
};

export default langIt_unicomm_cash;
